module.exports = __webpack_public_path__ + "07_medium_black.afa3475f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/07_medium_black.png
// module id = vgQk
// module chunks = 0